"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var recompose_1 = require("recompose");
var Uploader_1 = __importDefault(require("./Uploader"));
var lodash_1 = require("lodash");
var context_1 = __importDefault(require("../../utils/context"));
var loop_1 = __importDefault(require("material-ui/svg-icons/av/loop"));
var clear_1 = __importDefault(require("material-ui/svg-icons/content/clear"));
var reduxFormWrappers_1 = require("./reduxFormWrappers");
var muiThemeable_1 = __importDefault(require("material-ui/styles/muiThemeable"));
var react_redux_1 = require("react-redux");
var material_ui_1 = require("material-ui");
var ellipsisText = {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    marginRight: 'auto',
    minWidth: '20px',
};
var formatter = function (value) {
    return lodash_1.isEmpty(value) ? (react_1.default.createElement("span", null, "\u017E\u00E1dn\u00FD soubor")) : (react_1.default.createElement("a", { href: context_1.default() + "api/files/" + value.id, target: "_blank", style: ellipsisText }, value.name));
};
var View = function (props) { return react_1.default.createElement("div", null, props.disabled ? 'žádný soubor' : 'Klikněte pro vložení souboru'); };
var style = {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
};
var containerStyle = {
    display: 'flex',
    alignItems: 'flex-start',
    flexDirection: 'column',
    justifyContent: 'center',
    width: '100%',
};
var errorStyle = function (color) { return ({
    position: 'relative',
    width: 150,
    fontSize: 12,
    lineHeight: '12px',
    color: color,
    borderTop: 'solid 2px ' + color,
}); };
var Upload = function (_a) {
    var disabled = _a.disabled, value = _a.value, View = _a.View, formatter = _a.formatter, toggle = _a.toggle, mode = _a.mode, muiTheme = _a.muiTheme, handleComplete = _a.handleComplete, internalError = _a.internalError, errorText = _a.errorText, uploader = __rest(_a, ["disabled", "value", "View", "formatter", "toggle", "mode", "muiTheme", "handleComplete", "internalError", "errorText"]);
    var errorColor = muiTheme.textField.errorColor;
    var error = internalError || errorText;
    return (react_1.default.createElement("div", { style: containerStyle },
        lodash_1.isEmpty(value) ? (disabled ? (react_1.default.createElement(View, { disabled: disabled })) : (react_1.default.createElement(Uploader_1.default, __assign({ onComplete: handleComplete }, uploader),
            react_1.default.createElement(View, { disabled: disabled })))) : (react_1.default.createElement("div", { style: style },
            formatter(value),
            !disabled && (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(Uploader_1.default, __assign({ onComplete: handleComplete }, uploader),
                    react_1.default.createElement(loop_1.default, null)),
                react_1.default.createElement(material_ui_1.IconButton, { onClick: function () { return handleComplete({ response: null }); } },
                    react_1.default.createElement(clear_1.default, null)))))),
        !lodash_1.isEmpty(error) && react_1.default.createElement("div", { style: errorStyle(errorColor) }, error)));
};
var ComposedUpload = recompose_1.compose(muiThemeable_1.default(), recompose_1.defaultProps({ View: View, formatter: formatter, url: 'not-an-url' }), recompose_1.withState('internalError', 'setInternalError', ''), react_redux_1.connect(function (state, props) { return ({
    values: lodash_1.get(state, "form.FillerForm.values." + props.fieldName, []),
}); }), recompose_1.withHandlers({
    handleComplete: function (_a) {
        var values = _a.values, fieldName = _a.fieldName, onChange = _a.onChange;
        return function (complete) {
            return onChange(complete.response, fieldName + "[" + values.length + "]");
        };
    },
}))(Upload);
exports.default = ComposedUpload;
exports.FormUpload = reduxFormWrappers_1.formWrapper(ComposedUpload);
//# sourceMappingURL=Upload.js.map


//////////////////
// WEBPACK FOOTER
// .-core/es/components/controls/Upload.js
// module id = 282
// module chunks = 0